import { mountGame } from '../render/three/game-app.js';
import { pyramidSpec } from '../variants/pyramid/spec.js';

await mountGame(pyramidSpec);
